<template>
    <div
        :class="{ 'label-is-up': filled, 'has-error': error, rounded: rounded }"
        class="app-input-select"
    >
        <select
            :id="label"
            v-model="newValue"
            :disabled="disabled || loading"
            :placeholder="placeholderTrans"
            @change="onInput"
        >
            <option v-for="(value, label) in items" :key="label" :value="value"
                >{{ label }}
            </option>
        </select>

        <label :id="label">{{ label | __ }}</label>

        <div v-if="loading" class="loader" v-html="$icon('loader')"></div>

        <span class="line"></span>

        <p v-if="message" class="message">{{ message }}</p>
    </div>
</template>

<script>
export default {
    name: "app-input",

    props: {
        type: {
            type: String,
            default: "text"
        },
        value: [String, Number, Boolean],
        items: [Object],
        label: String,
        placeholder: String,
        error: Boolean,
        message: String,
        autofocus: Boolean,
        rounded: Boolean,
        loading: false,
        disabled: false
    },

    data() {
        return {
            newValue: this.value,
            focused: false
        };
    },

    watch: {
        value() {
            this.newValue = this.value;
        }
    },

    methods: {
        onInput() {
            this.$emit("input", this.newValue);
            this.$emit("change", this.newValue);
        }
    },

    computed: {
        filled() {
            return this.newValue || this.focused;
        },

        placeholderTrans() {
            return this.placeholder ? this.$trans(this.placeholder) : "";
        }
    }
};
</script>

<style lang="scss" scoped>
.app-input-select {
    display: block;
    position: relative;
    font-size: 25px;
    font-weight: $font-light;
    line-height: 0.8;
    color: $black;
    height: 50px;
    border-bottom: 1px solid $medium-gray;
    padding: 0 15px;

    &.rounded {
        border-radius: 100px;
        border: 1px solid rgba(33, 67, 146, 0.2);
        background: $lightest-gray;
        height: 50px;
        flex-shrink: 0;

        select {
            border-radius: 25px;
            padding: 0 15px;
        }

        .line {
            display: none;
        }
    }

    select {
        position: relative;
        z-index: 1;
        border: 0;
        display: block;
        width: 100%;
        font-size: 20px;
        font-weight: $font-light;
        color: $black;
        outline: none;
        height: 100%;
        padding: 6px 0;
        -moz-appearance: textfield;
        background: $lightest-gray;
    }

    input::-webkit-inner-spin-button,
    input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    label {
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        z-index: 2;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        pointer-events: none;
        transition: all 0.2s ease-in-out;
        padding: 0 18px;
        color: rgba(0, 0, 0, 0.6);
        font-size: 18px;
        font-weight: $font-normal;
    }

    .loader {
        position: absolute;
        width: 1em;
        height: 1em;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;

        ::v-deep svg {
            stroke: black;
        }
    }

    .line {
        position: absolute;
        display: block;
        left: 50%;
        width: 0;
        bottom: -1px;
        height: 1px;
        z-index: 3;
        transform: translateX(-50%);
        background-color: $primary-blue;
        transition: all 0.4s ease-in-out;
    }

    &.label-is-up select,
    select:focus {
        + label {
            transform: translateY(-90%) translateX(18px);
            font-weight: $font-bold;
            font-size: 15px;
        }

        + label + .line {
            width: 100%;
        }
    }

    .message {
        font-size: 0.7em;
        margin: 10px 0 0;
        color: $error-red;
        font-weight: $font-normal;
    }
}
</style>
